import { Fragment, FC } from "react";
import { Box, Card, CardContent, Typography } from "mui";

import { AppCardProps } from "types/AppCard";
import { getIcon } from "components/icons";
import clsx from "clsx";

import styles from "components/AppCard/AppCard.module.scss";

const AppCard: FC<AppCardProps> = ({
  description,
  iconName,
  id,
  isSelected,
  title,
  onClick,
}: AppCardProps) => {
  const IconComponent = getIcon(iconName);
  return (
    <Fragment>
      <Card
        className={clsx(styles.appCard, isSelected && styles.appCardSelected)}
        onClick={() => onClick(id)}
      >
        <Box className={styles.iconContainer}>
          <div
            className={clsx(
              styles.iconButton,
              isSelected && styles.iconButtonSelected
            )}
          >
            {IconComponent && (
              <IconComponent color={isSelected ? "#FFFFFF" : "#215585"} />
            )}
          </div>
        </Box>
        <CardContent>
          <Typography className={styles.cardTitle} variant="h3">
            {title}
          </Typography>
          <Typography variant="body1">{description}</Typography>
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default AppCard;
